import React from "react"
import PropTypes from "prop-types"
import { createStructuredSelector } from "reselect"
import "app/static/stylus/reusable_components/attachments.styl"
import AttachmentCard from "components/AttachmentCard"
// Redux stuff
import { connect } from "react-redux"
import { deleteAttachment } from "outbox/action-creators"
import { deleteTemplateAttachment } from "outbox/templates/action-creators"
import { getAttachments } from "shared/outbox/selectors"
import * as templateSelectors from "outbox/templates/selectors"

/*
 * The AttachmentViewer displays a list of uploaded attachments.
 */
const AttachmentViewer = (props) => (
    <div className="attachments-viewer">
        {props.attachments.map((attachment) => (
            <AttachmentCard
                key={attachment.id}
                id={attachment.id}
                hideDelete={props.hideDelete}
                name={attachment.name}
                size={attachment.size}
                deleteAttachment={props.deleteAttachment}
                onAttachmentClick={props.onAttachmentClick}
                canPreview={props.canPreview || attachment.canPreview}
                {...props}
            />
        ))}
        {props.showEllipsis && "..."}
    </div>
)

AttachmentViewer.propTypes = {
    attachments: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            size: PropTypes.number,
        }),
    ),
    hideDelete: PropTypes.bool,
    canPreview: PropTypes.bool,
    deleteAttachment: PropTypes.func,
    onAttachmentClick: PropTypes.func,
    showEllipsis: PropTypes.bool,
}
AttachmentViewer.defaultProps = {
    attachments: [],
    hideDelete: false,
    showEllipsis: false,
}
export default AttachmentViewer

/* +++++++++++++++
 * + CONNECTIONS +
 * +++++++++++++++
 */
// set canPreview to be false by default for outbox connected components
const mergeProps = (stateProps, dispatchProps, ownProps) =>
    Object.assign({}, stateProps, dispatchProps, ownProps, {
        canPreview: false,
    })

// this is the viewer for outbox
const outboxStateToProps = createStructuredSelector({ attachments: getAttachments })
const outboxDispatch = { deleteAttachment }
export const OutboxAttachmentViewer = connect(outboxStateToProps, outboxDispatch, mergeProps)(AttachmentViewer)

const templateStateToProps = createStructuredSelector({
    attachments: templateSelectors.getAttachments,
})
const templateDispatch = {
    deleteAttachment: deleteTemplateAttachment,
}
export const TemplateAttachmentViewer = connect(templateStateToProps, templateDispatch, mergeProps)(AttachmentViewer)
